export const PRODUCT_REQUIREMENT_LIST_REQUEST =
  "PRODUCT_REQUIREMENT_LIST_REQUEST";
export const PRODUCT_REQUIREMENT_LIST_SUCCESS =
  "PRODUCT_REQUIREMENT_LIST_SUCCESS";
export const PRODUCT_REQUIREMENT_LIST_FAIL = "PRODUCT_REQUIREMENT_LIST_FAIL";
export const PRODUCT_REQUIREMENT_LIST_RESET = "PRODUCT_REQUIREMENT_LIST_RESET";

export const PRODUCT_REQUIREMENT_SINGLE_REQUEST =
  "PRODUCT_REQUIREMENT_SINGLE_REQUEST";
export const PRODUCT_REQUIREMENT_SINGLE_SUCCESS =
  "PRODUCT_REQUIREMENT_SINGLE_SUCCESS";
export const PRODUCT_REQUIREMENT_SINGLE_FAIL =
  "PRODUCT_REQUIREMENT_SINGLE_FAIL";
export const PRODUCT_REQUIREMENT_SINGLE_RESET =
  "PRODUCT_REQUIREMENT_SINGLE_RESET";

export const CREATE_PRODUCT_REQUIREMENT_REQUEST =
  "CREATE_PRODUCT_REQUIREMENT_REQUEST";
export const CREATE_PRODUCT_REQUIREMENT_SUCCESS =
  "CREATE_PRODUCT_REQUIREMENT_SUCCESS";
export const CREATE_PRODUCT_REQUIREMENT_FAIL =
  "CREATE_PRODUCT_REQUIREMENT_FAIL";
export const CREATE_PRODUCT_REQUIREMENT_RESET =
  "CREATE_PRODUCT_REQUIREMENT_RESET";

export const UPDATE_PRODUCT_REQUIREMENT_REQUEST =
  "UPDATE_PRODUCT_REQUIREMENT_REQUEST";
export const UPDATE_PRODUCT_REQUIREMENT_SUCCESS =
  "UPDATE_PRODUCT_REQUIREMENT_SUCCESS";
export const UPDATE_PRODUCT_REQUIREMENT_FAIL =
  "UPDATE_PRODUCT_REQUIREMENT_FAIL";
export const UPDATE_PRODUCT_REQUIREMENT_RESET =
  "UPDATE_PRODUCT_REQUIREMENT_RESET";

export const DELETE_PRODUCT_REQUIREMENT_REQUEST =
  "DELETE_PRODUCT_REQUIREMENT_REQUEST";
export const DELETE_PRODUCT_REQUIREMENT_SUCCESS =
  "DELETE_PRODUCT_REQUIREMENT_SUCCESS";
export const DELETE_PRODUCT_REQUIREMENT_FAIL =
  "DELETE_PRODUCT_REQUIREMENT_FAIL";
export const DELETE_PRODUCT_REQUIREMENT_RESET =
  "DELETE_PRODUCT_REQUIREMENT_RESET";
